import movingSquareLine from "./moving-square-line.html";
import "./moving-square-line.css";

export default movingSquareLine;